<template>
  <div>
    <a-row :gutter="[24, 24]">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
      >
        <a-alert type="success" style="text-align: center">
          <span slot="message" style="font-size: 20px">
            <div style="text-align: left">
              Perturbation cluster :
              <span style="color: red; font-weight: bolder">{{
                this.$route.query.pcID
              }}</span
              >, derived from
              <span style="color: red; font-weight: bolder">{{
                this.datasetid
              }}</span>
            </div>
          </span>
        </a-alert>
      </a-col>
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
      >
        <a-card
          size="small"
          style="border-radius: 5px; border-color: green; margin-left: 5px"
          hoverable
          :headStyle="{ backgroundColor: 'green', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px; color: white">
            Members
          </a>
          <members />
        </a-card>
      </a-col>
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
      >
        <a-card
          size="small"
          style="border-radius: 5px; border-color: green; margin-left: 5px"
          hoverable
          :headStyle="{ backgroundColor: 'green', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px; color: white">
            Complex Annotation
          </a>
          <complex />
        </a-card>
      </a-col>
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
      >
        <a-card
          size="small"
          style="border-radius: 5px; border-color: green; margin-left: 5px"
          hoverable
          :headStyle="{ backgroundColor: 'green', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px; color: white">
            Pathway Annotation
          </a>
          <kegg />
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import kegg from "./keggTable.vue";
import complex from "./complexTable.vue";
import members from "./gene_table.vue";
import axios from "axios";

export default {
  components: { kegg, complex, members },
  mounted() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/clusters/pcToID.php", {
        params: {
          clusterID: this.$route.query.pcID,
        },
      })
      .then((response) => {
        this.datasetid = response.data;
      });
  },
  methods: {
    handleChange(value) {
      this.value = value;
      console.log(this.datasetlist[this.value]);
      this.datasetId = this.datasetlist[this.value];
    },
  },
  data() {
    return {
      datasetid: "",
    };
  },
};
</script>
<style scoped></style>
